module.exports = __webpack_public_path__ + "static/img/TYLER-WELSH.5e966c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TYLER-WELSH.jpg
// module id = 8A14
// module chunks = 0